import React from 'react';
import Hero from './components/university-news-letter/Hero';
import Main from './components/university-news-letter/Main';

const UniversityNewsLetter = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default UniversityNewsLetter;